import { render, staticRenderFns } from "./NewsItem1.vue?vue&type=template&id=3fa21e8a"
import script from "./NewsItem1.vue?vue&type=script&lang=ts"
export * from "./NewsItem1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports